export const SITE_NAME = 'Sorvaine';
export const BASE_URL = 'https://sorvaine.com';
export const TAGLINE = 'The intelligence to win.';
